<template>
  <div id="editDictionary">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{path:'/DictionariesList',query: {skillId: this.skillId,online:this.online}}">词典列表</el-breadcrumb-item>
      <el-breadcrumb-item>编辑词典</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="intentionInfo">
      <p class="title">编辑词典</p>
      <div class="intentionContainer">
        <el-form label-width="110px" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="词典中文名" prop="Chinese">
            <el-tooltip content="词典中文名称(2~50个字符,仅支持中文) 保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input v-model='ruleForm.Chinese' type='text' :minlength="2" :maxlength="50"
                      placeholder="请输入中文名称" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="词典标识名" prop="distinguish">
            <el-tooltip content="词典调用名称(2~50个字符,仅支持数字,字母,下划线) 保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input v-model='ruleForm.distinguish' type='text' :minlength="2" :maxlength="50"
                      placeholder="请输入调用名称" @input.native="changeRoute"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div id="oftenInfo">
      <p class="title">
        <span>词表</span>
        <!-- <el-button type="primary" round size="mini" class="pull-right" @click="dialogFormVisible = true">批量导入</el-button> -->
        <el-button type="primary" round size="mini" class="pull-right" @click="exportDic">导出</el-button>
      </p>
      <div class="intentionContainer">
        <el-table
          :data="tableData"
          style="width: 100%;">
          <el-table-column
            align="center"
            label="填写词"
          >
            <template slot-scope="scope">
              <div class="sort-button">
                <el-input class="slotButton" type='text' v-model='scope.row.value' @blur="onlyNum(scope.row)"
                          placeholder="请输入填写词"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="synonyms"
            label="同义词"
            align="center"
          >
            <template slot-scope="scope">
              <div class="sort-button">
                <el-input class="slotButton" type='text' v-model='scope.row.synonyms' @blur="onlyNum(scope.row)"
                          placeholder="请输入同义词"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="操作"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.date}}</span>
              <el-button @click="handleClick(scope.row)" type="text" size="small" v-if='scope.row.date==""'>添加词条
              </el-button>
              <el-button @click="deleteRow(scope.row)" type="text" size="small" v-else><i
                class="el-icon-circle-close deleteIcon"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div style="padding:0 30px" id="table_list">
          <table class="table text-center">
            <thead>
            <tr>
              <th class="text-center">填写词</th>
              <th class="text-center">同义词</th>
              <th class="text-center">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <input type="text" class="input_text">
              </td>
              <td>
                <input type="text" class="input_text" placeholder="请输入中文名称">
              </td>
              <td>
                <a href="###">添加槽位</a>
                <button class="btn">X</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>-->
      </div>

      <div style="text-align: center">
        <!--<el-pagination-->
          <!--@current-change="handleCurrentChange"-->
          <!--prev-text="上一页" next-text="下一页"-->
          <!--:current-page.sync=page-->
          <!--:page-size="10"-->
          <!--layout="prev, pager, next"-->
          <!--:total='editLength'>-->
        <!--</el-pagination>-->
      </div>
      <div class='page'>
        <el-button class="intentSavebtn" type="primary" round id="Preservation" size="mini" @click='onSubmit'>保存</el-button>
      </div>
    </div>
    <el-dialog
      title="批量导入"
      :visible.sync="dialogFormVisible"
      width="40%"
      :before-close="handleClose">
      <el-upload class="fileUpLoad"
                 action="https://jsonplaceholder.typicode.com/posts/"
                 :show-file-list="false"
                 :on-success="handleFileSuccess"
                 :before-upload="beforeFileUpload"
                 :file-list="fileList">
        <el-button type="primary">导入词典文件</el-button>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小不要超过10M</span>
      </el-upload>
      <p class="filePrompt">导入CSV 格式的词库文件,只支持utf8编码,内容格式请参考：<a href="/images/logo.png" download="模板.csv"><span
        class='muban' @click='muban()'>模板.csv</span></a></p>
      <div class='grey'><span style="color:#67c23a">导入成功:&nbsp;&nbsp;&nbsp;</span>成功&nbsp;n&nbsp;条&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;失败&nbsp;n&nbsp;条&nbsp;&nbsp;&nbsp;&nbsp;重复&nbsp;n&nbsp;条
      </div>


      <!--  <el-button @click="dialogFormVisible = false">取 消</el-button> -->
      <!--  <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button> -->
    </el-dialog>

  </div>
</template>
<script>
  import * as API from '@/api'
  /*  import exportDictApi*/
  import {exportDictApi, serviceHost} from '@/api'
  import qs from 'qs'

  export default {
    created() {
      // console.log(this.$route.query.skillId)
      // console.log(this.$route.query.dict_id)
      this.tabindexNumChange()
      if (this.$route.query.skillId && this.$route.query.dict_id) {
        this.getData(1);
      }

    },
    data() {
      var checkDis = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[a-zA-Z0-9_]+$");
          if (!reg.test(value)) {

//            this.$message.error('请输入正确的字典标识，仅支持数字，字母，下划线')
            callback(new Error('仅支持数字，字母，下划线'));
          } else {
            callback();
          }
        }, 100);
      }
      var checkChinese = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
//            this.$message.error('请输入正确的字典名，2~50个汉字')
            callback(new Error('仅支持中文'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        skillId: this.$route.query.skillId,
        online: this.$route.query.online,
        dict_id: this.$route.query.dict_id,
        tableData: [{
          date: '',
          value: '',
          synonyms: ''
        }
          //   , {
          //     value: '1',
          //     synonyms: '王小虎1'
          //   }, {
          //     value: '2',
          //     synonyms: '王小虎2'
          //   }, {
          //     value: '3',
          //     synonyms: '王小虎3'
          //   }, {
          //     value: '4',
          //     synonyms: '王小虎4'
          // }
        ],
        ruleForm: {
          Chinese: '',
          distinguish: ''
        },
        rules: {
          Chinese: [
            {required: true, message: '请输入词典中文名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个汉字', trigger: 'blur'},
            {validator: checkChinese, trigger: 'blur'}
          ],
          distinguish: [
            {required: true, message: '请输入词典识别名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'},
            {validator: checkDis, trigger: 'blur'}
          ],
        },
        fileList: [{
          name: 'food.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }, {
          name: 'food2.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }],
        dialogFormVisible: false,
        page: 1,
        deleteList: [],
        addList: [],
        editList: [],
        editLength: 0,
        tabindexNum:"-1",
      }
    },
    methods: {
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      tabindexNumChange(){
        this.tabindexNum = "-1";
      },
      getData(num) {
        let params = {
          'show_user_dict': this.dict_id
        }
        // console.log(params)
        API.postDictPage(this.skillId, num, params).then((res) => {
          if (res.code == 200) {
            //let index =this.tableData.indexOf(row)
            //this.tableData.splice(index,1)
            this.ruleForm.Chinese = res.data.chinese_name;
            this.ruleForm.distinguish = res.data.dict_name.substring(5,)
            for (let i = 0; i < res.data.words.length; i++) {
              this.editLength = res.data.words.length
              this.tableData.push({
                'value': res.data.words[i].value,
                'synonyms': res.data.words[i].synonyms.join(','),
                'word_id': res.data.words[i].word_id
              })
            }
            // for(let i=0;i<res.data.length;i++){
            //   this.editLength=res.data.length
            //   this.tableData.push({'value':res.data[i].value,'synonyms':res.data[i].synonyms.join(',')})
            // }

          } else {
            this.$message.error('获取失败')
          }
          //this.tableData = res.data
        }, (err) => {
          this.$message.error('连接错误')
        })
      },
      //导出词典
      async exportDic() {
        //alert(1);
        let res = await exportDictApi({skill_id:this.skillId,dict_id:this.dict_id});
        if (res.data.code == 200) {

  //this.$message({message: '导出成功', type: 'success'})
         window.location.href=res.data.data.url;
          //http://10.100.37.21:5000/dicts/user/export?data=skill_id=orion.ovs.skill.1521098367849&dict_id=u3rfKoucT32sogyYLYvQRB
        } else {
          this.$message({message: '导出失败', type: 'error'})
          return
        }
        //console.log(serviceHost+"/dicts/user/export?skill_id="+this.skillId+"&dict_id="+this.dict_id);
        //window.location.href=serviceHost+"/dicts/user/export?skill_id="+this.skillId+"&dict_id="+this.dict_id;


      },

      handleClick: function (ele) {
        if (this.tableData[0].value !== '') {
          let reg = /[^\u4e00-\u9fa5A-Za-z]/g
          if (reg.test(this.tableData[0].value)) {
            this.$message({message: '请填写正确填写词,仅中英文', type: 'error'})
            return
          }
          let reg2 = /[^\u4e00-\u9fa5,a-zA-Z]/g
          if (reg2.test(this.tableData[0].synonyms)) {
            this.$message({message: '请填写正确同义词,仅中英文、英文逗号', type: 'error'})
            return
          }
          delete this.tableData[0].date
          this.tableData.unshift(
            {
              date: '',
              value: '',
              synonyms: ''
            })
        } else {
          this.$message.error('填写词不能为空')
          return;
        }
        // this.addList.push({'value':this.tableData[0].value,'synonyms':this.tableData[0].synonyms.split(',')})
        // console.log('211112')
        // console.log(this.tableData)
        // delete this.tableData[0].date
        // this.tableData.unshift(
        //   {
        //     date:'',
        //     value: '',
        //     synonyms: ''
        //   })
      },
      onlyNum(row) {
        //row.rerank = parseInt(row.rerank) || 0;
      },
      deleteRow(row) {
        // this.$options.methods.openNotifyConfirm.bind(this)(row);
        this.$confirm('是否删除此词表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let index = this.tableData.indexOf(row);
          this.tableData.splice(index, 1);
          this.deleteList.push(row.word_id)
          //console.log(row.word_id)
          this.editLength--;
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      openNotifyConfirm(row) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleFileSuccess(res, file) {
//        console.log(res.file_name);
      },
      beforeFileUpload(file) {
        // console.log(file.type)
        var fileSize = 0;
        if (file.size > 1024 * 1024) {
          var Size = Math.round(file.size * 100 / (1024 * 1024)) / 100;
          if (Size > 10) {
            this.$alert('文件不能大于10M哟_(•̀ω•́ 」∠)_', '温馨提示', {});
            return false;
          }
          fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
        }
        else {
          fileSize = (Math.round(file.size * 100 / 1024) / 100).toString() + 'KB';
        }
        if (file.type.substr(file.type.length - 3) !== 'csv') {
          this.$alert('请上传csv的格式文件哟_(•̀ω•́ 」∠)_', '温馨提示', {});
          return false;
        }
        if (file) {
          // this.form.audioUrl = file.name
          // this.showPercent = true;
          // let _this=this
          // var myVar = setInterval(function(){
          //   if(_this.proPercent<100){
          //      _this.proPercent+=1
          //      if(_this.proPercent>80){
          //         stop();
          //         console.log('12312312')
          //      }
          // }
          // },500)
          // function stop(){
          //   console.log('stop')
          //   clearInterval(myVar);
          // }

        }
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
      },
      muban() {
        console.log('212121')
      },
      async sub(params) {
        params['edit_user_dict'][0]['edit_list'] = params['edit_user_dict'][0]['edit_list'].filter(item => {
          return item.word_id != undefined
        })
        let res = await API.postDict(this.skillId, this.page, qs.stringify(params))
        if (res.code == 200) {
          this.$message({
            message: '保存词典成功',
            type: 'success'
          });
          this.tableData[0].synonyms = ''
          this.tableData[0].value = ''
        } else {
          this.$message.error('当前网络状况异常，请稍后再试');
//          this.$message.error(res.msg);
        }
//        API.postDict(this.skillId, this.page, qs.stringify(params)).then((res) => {
//          if (res.code == 200) {
//            this.$message({
//              message: '保存词典成功',
//              type: 'success'
//            });
//            // this.$router.push({path: '/dictionariesList',query: {skillId: this.skillId}})
//          } else {
//            this.$message.error(res.msg);
//          }
//          console.log(res)
//        }, (err) => {
//          this.$message.error('连接错误');
//        })
      },
      onSubmit() {
        this.$store.dispatch('changeR',true);
        let reg = /[^\u4e00-\u9fa5A-Za-z]/g
        let reg2 = /[^\u4e00-\u9fa5,A-Za-z]/g
        for (let i = 0; i < this.tableData.length; i++) {
          let cur = this.tableData[i]
          console.log(cur)
          if (reg.test(cur.value)) {
            this.$message({message: '请填写正确填写词,仅中英文', type: 'error'})
            this.$root.scroll_top()
            return
          }
          if (reg2.test(cur.synonyms)) {
            this.$message({message: '请填写正确同义词,仅中英文、英文逗号', type: 'error'})
            this.$root.scroll_top()
            return
          }
        }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var editList = this.tableData.slice(-this.editLength,)
            this.tableData[0].value = '';
            this.tableData[0].synonyms = '';
            if (this.tableData[0].value == "") {
//              delete this.tableData[0].date
              this.addList = this.tableData.slice(1, this.tableData.length - this.editLength)
            } else {
//              delete this.tableData[0].date
              this.addList = this.tableData.slice(0, this.tableData.length - this.editLength)
            }

            var addList1 = []
            for (let i = 0; i < this.addList.length; i++) {
              let synonyms = []
              if (this.addList[i].synonyms.indexOf(',') !== -1) {
                synonyms = this.addList[i].synonyms.split(',')
              }
              else if (this.addList[i].synonyms.indexOf('，') !== -1) {
                synonyms = this.addList[i].synonyms.split('，')
              } else {
                synonyms.push(this.addList[i].synonyms)
              }
              addList1.push({'value': this.addList[i].value, 'synonyms': synonyms})
            }
            var editList1 = []

            for (let i = 0; i < editList.length; i++) {
              let synonyms = []
              if (editList[i].synonyms.indexOf(',') !== -1) {
                synonyms = editList[i].synonyms.split(',')
              }
              else if (editList[i].synonyms.indexOf('，') !== -1) {
                synonyms = editList[i].synonyms.split('，')
              } else {
                synonyms.push(editList[i].synonyms)
              }
              editList1.push({'value': editList[i].value, 'synonyms': synonyms, 'word_id': editList[i].word_id})
            }


            // console.log(this.deleteList)
//            if (addList1.length == 1) {
//              addList1 = []
//            } else {
//              addList1.shift()
//            }
            let params = {
              "edit_user_dict": [{
                "dict_name": this.ruleForm.distinguish,
                "chinese_name": this.ruleForm.Chinese,
                'dict_id': this.dict_id,
                'skillId': this.skillId,
                "delete_list": this.deleteList,
                "edit_list": editList1,
                "add_list": addList1
              }]
            }
            this.sub(params)
          } else {
            this.$root.scroll_top()
          }
        })
      },
      handleCurrentChange(val) {
//        console.log(`当前页: ${val}`);
        this.page = val;
        this.getData(val);
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">

  #editDictionary {
    background: #f7f7f7;
    input {
      width: 200px;
      height: 28px;
      border-radius: 14px;
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      .pull-right {
        float: right;
        margin: 20px 20px 0 0;
      }
    }
    #intentionInfo {
      background: #fff;
      .intentionContainer {
        padding: 30px;
        height:auto;
      }
    }
    #oftenInfo {
      background: #fff;
      margin-top: 26px;
      #table_list {
        table {
          margin: 0;
          td {
            position: relative;
            input {
              position: absolute;
              left: 0;
              top: 0;
              padding: 10px;
              border: none;
              outline: none;
            }
          }
        }
      }
    }

    .intentionContainer {
      padding: 30px;
      padding-top: 0;
      height: auto;
    }
    .el-input__inner {
      width: 420px;
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
    }
    .dict {
      width: 100px;
    }
    .deleteIcon {
      font-size: 20px;
      color: #ccc;
    }
    .deleteIcon:hover {
      color: #f56c6c;
    }
    .fileUpLoad {
      margin: 0px auto;
    }
    .filePrompt {
      margin-top: 10px;
    }
    .muban {
      color: #6db5ff;
      cursor: pointer;
    }
    .grey {
      background: #f7f7f7;
      padding-left: 20px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -115px;
        margin-top: -1px;
      }
    }

    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }

    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .el-form-item__label {
      padding-right: 20px;
    }
    .dictionaries-table {
      td {
        text-align: center;
      }
    }
    .page {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }
    .sort-button {
      margin: 0 auto;
      .el-input__inner {
        width: 80%;
        margin: 0 auto;
        border-radius: 14px;
        text-align: center;
      }
    }
    .intentSavebtn {
      width: 90px;
      height: 32px;
      i {
        margin-top: -10px;
        vertical-align: middle;
      }
    }
    .intentSavebtn1 {
      width: 120px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/skill/dictionaries/EditDictionaries.vue